<template>
  <ui-row v-if="type">
    <ui-col v-if="!bookList.length" align-self="center" col="1">
      <ui-spinner></ui-spinner>
    </ui-col>
    <ui-col v-if="bookList.length">
      <ui-loader :loading="loading" :lang="loaderLang" :completed="completed" :listens="['pull-down', 'scroll', 'pull-up']" @scroll="scroll" @pull-down="pullDown" @pull-up="pullUp">
        <ui-row class="book-list">
          <ui-col v-for="book of stickyBookList" :key="book._id" col="12" col-sm="6" col-lg="4">
            <card-book :book="book" card-shadow> </card-book>
          </ui-col>
          <ui-col v-for="book of bookList" :key="book._id" col="12" col-sm="6" col-lg="4">
            <card-book :book="book" card-shadow> </card-book>
          </ui-col>
        </ui-row>
      </ui-loader>
    </ui-col>
  </ui-row>
</template>
<script>
import api from "../../api/index";
import { mapGetters } from "vuex";
import CardBook from "../card/card-book.vue";
export default {
  name: "BookList",
  data() {
    return {
      stickyBookList: [],
      limit: 12,
      bookList: [],
      loading: false,
      completed: false,
      loaderLang: {
        pullDownToRefresh: this.$t("pullDownToRefresh"),
        releaseToRefresh: this.$t("releaseToRefresh"),
        pullUpToLoad: this.$t("pullUpToLoad"),
        loadCompleted: this.$t("loadCompleted")
      }
    };
  },
  computed: {
    skip() {
      return this.bookList.length;
    }
  },
  components: {
    CardBook
  },
  props: {
    title: String,
    type: String,
    isPrivate: Boolean
  },
  mounted() {
    if (this.type == "public" && !this.stickyBookList.length) {
      this.fetchStickyData();
    }
    if (!this.bookList.length) {
      this.fetchData();
    }
  },
  watch: {
    isPrivate() {
      this.bookList = [];
      this.stickyBookList = [];
      this.fetchStickyData();
      this.fetchData();
    }
  },
  methods: {
    scroll() {
      this.fetchData();
    },
    pullDown() {
      this.bookList = [];
      this.fetchData();
    },
    pullUp() {
      this.fetchData();
    },

    fetchData() {
      this.loading = true;
      this.completed = false;
      api
        .getBookList({
          type: this.type,
          limit: this.limit,
          skip: this.skip,
          isPrivate: this.isPrivate ? 1 : ""
        })
        .then(res => {
          this.loading = false;
          if (res.status == 200) {
            this.bookList = this.bookList.concat(res.data.bookList);
          }
          if (res.status == 204) {
            this.completed = true;
          }
        });
    },
    fetchStickyData() {
      api
        .getBookList({ type: "sticky", isPrivate: this.isPrivate ? 1 : "" })
        .then(res => {
          if (res.status == 200) {
            this.stickyBookList = res.data.bookList;
          }
          if (res.status == 204) {}
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};

</script>
<style lang="scss"></style>
